// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"vHCk64yOGMlBfNQ4YwiFt","topBlock":"_3IoA-XYgsQDSKrjRCRbkXp","title":"W2u4Jn2iReau6x3qqmhdi","navigationWrapper":"OG5GA08KKzGzccVBeJZ4s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/SliderCart/SliderCart.scss
// module id = 1704
// module chunks = 0